import { YearInReviewButton } from "@ugitgud/legos/ui/form/button/YearInReviewButton";
import { Icon } from "@ugitgud/legos/ui/icon/Icon";
import { SvgMiscX } from "@ugitgud/legos/ui/icon/SVG/MiscX";
import classNames from "classnames";
import { SvgYearInReviewLogoFull } from "@ugitgud/legos/ui/icon/SVG/year-in-review/YearInReviewLogoFull";

export const YEAR_IN_REVIEW_BANNER_CTA = "year-in-review-cta";

interface YearInReviewBannerProps {
  url: string;
  className?: string;
  onClick: (url: string) => void;
  onClose?: () => void;
  utmSource?: string;
}

export function YearInReviewBanner(props: YearInReviewBannerProps) {
  const { url, onClick, onClose, className, utmSource } = props;
  const href = utmSource ? `${url}?utm_source=${utmSource}` : url;

  const onUrlClick = (e: React.MouseEvent) => {
    e.preventDefault();
    onClick(href);
  };

  return (
    <div
      className={classNames(
        "w-full h-[48px] bg-[#11173D] flex justify-end relative overflow-hidden border-b border-b-[#1E3246]",
        className,
      )}
    >
      <div
        className={classNames(
          "relative h-[48px] w-full shrink-0",
          "bg-no-repeat bg-cover",
          "[background-image:linear-gradient(to_left,transparent,80%,#11173D_100%),url('https://static.bigbrain.gg/assets/ugg/cta/year-in-review-banner.png')]",
          "[background-postition:60%_top] [background-size:200%_auto]",
          "xs:[background-position:right%_0.5%] sm:[background-size:80%_auto]",
          "sm:[background-position:180%_0.5%] sm:[background-size:80%_auto]",
          "md:[background-position:110%_0.5%] md:[background-size:62.5%_auto]",
          "lg:[background-position:right_3%] lg:[background-size:62.5%_auto]",
          "xl:[background-position:right_3%] xl:[background-size:44.5%_auto]",
          //"sm:[background-position:calc(50%+500px)_center]",
          //"md:[background-position:calc(50%+450px)_center]",
          //"lg:[background-position:calc(50%+400px)_center]",
          //"xl:[background-position:calc(50%+150px)_center]",
          //"2xl:[background-position:calc(50%+200px)_center]",
        )}
        style={{ aspectRatio: "379/12" }}
      />
      <div
        className={classNames(
          "absolute inset-0 z-10 flex items-center justify-center gap-[13px] xs:gap-[41px] sm:gap-[56px]  px-4 sm:px-6 md:px-8 text-white",
          { "pr-10": onClose },
        )}
      >
        <div className="flex items-center gap-3">
          <SvgYearInReviewLogoFull className="w-[30px] h-[30px]" />
          <div className="flex flex-col [text-shadow:0px_1px_0px_rgba(0,_0,_0,_0.50)]">
            <div className="relative -top-0.5 uppercase font-barlow font-semibold text-[18px] leading-[18px] text-center xs:text-left whitespace-nowrap">
              <span className="hidden xxs:inline">YEAR IN REVIEW</span>
            </div>
            <div className="font-inter font-medium text-[12px] leading-[12px] hidden xs:block text-center sm:text-left text-[#CDDCFE]">
              A personally curated summary of your 2025 stats
            </div>
          </div>
        </div>
        <YearInReviewButton
          href={`${href}?utm_source=topbanner`}
          onClick={onUrlClick}
          className="p-2 sm:px-3 sm:py-2 space-x-2 sm:space-x-3 flex items-center"
        >
          <div className="text-[12px] sm:text-[13px] font-bold whitespace-nowrap">Generate Yours Now</div>
        </YearInReviewButton>
      </div>

      {onClose && (
        <div
          className="absolute z-20 top-1/2 right-[12px] -translate-y-1/2 p-[6px] cursor-pointer hover:opacity-50"
          onClick={onClose}
        >
          <Icon icon={<SvgMiscX />} size="xs" className="fill-white drop-shadow-[0px_1px_0px_rgba(0,_0,_0,_0.50)]" />
        </div>
      )}
    </div>
  );
}
